import React from 'react';
import {PageTitle, SingleText} from "../../_components";
import {Link, useParams} from "react-router-dom";
import {useAuth} from "../../../context";
import {useGetJson, usePostJson} from "../../../hooks";
import {endpoints} from "../../../utils2";
import {WhiteCard} from "../_components/WhiteCard";
import {Formik, Form as FormikForm} from "formik";
import * as yup from "yup";
import {Alert, Button, Stack} from "react-bootstrap";

export function ThirdPartyConfiguration() {
    const {uid, did} = useParams()
    const {authToken} = useAuth()

    const [dev, loadingDevice, errorDevice, clearErrorDevice] = useGetJson(endpoints.device.get(uid, did), authToken?.jwt)
    const device = dev?.data

    const [sendData, v, postLoading, postError, clearPostError] = usePostJson(endpoints.device.edit(uid, did), authToken?.jwt)


    const validationSchema = yup.object().shape({
        // third: yup.string().required("NTP is required"),
    })

    const initialValues = {
        third: "",
    }

    function handleSubmit(values, action) {
        // sendData(values, json => {
        //     action.setSubmitting(false)
        //     navigate(-1)
        // })
        console.log("submit", values)
    }

    return <>
        <Alert variant="danger" show={errorDevice} dismissible onClose={clearErrorDevice}>{errorDevice}</Alert>
        <Alert variant="danger" show={postError} dismissible onClose={clearPostError}>{postError}</Alert>

        <PageTitle title="Third Party Configuration">{device?.name}</PageTitle>

        <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={initialValues}
                enableReinitialize={true}>
            {({isSubmitting}) => (
                <FormikForm>
                    <WhiteCard>
                        <SingleText name="third" label="Password" disabled placeholder="Password"/>
                    </WhiteCard>

                    <div className="fw-semibold fs-5">Code examples</div>
                    <WhiteCard>
                        <div>
                            Python code example 1: <code>print("Altrabits Third-Party!")</code>
                        </div>
                    </WhiteCard>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        <Button as={Link} variant="link" to={-1}>Go back</Button>
                        {/*<Button type="submit" variant="primary" disabled={isSubmitting}>Edit</Button>*/}
                        <Button type="submit" variant="primary" disabled>Edit</Button>
                    </Stack>
                </FormikForm>
            )}
        </Formik>
    </>
}
